import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { LabAffiliation } from '../models/lab-affiliation.model';
import { AppConfig } from '../../../../../app/config/app-config';
import { map, catchError, delay } from 'rxjs/operators';
import { LabInfo } from '../models/lab-info.model';
import { ActivityValidation } from '../models/activity-validation.model';

@Injectable({
    providedIn: 'root',
})
export class ClaimCmeCeService {
    getLabDetailsFromCapNumber$(capNumber: string): Observable<LabAffiliation> {
        const api = AppConfig.settings.apiServer.details.labInfo;

        const query = `/organization/${capNumber}`;

        const url = api + query;

        return this.http.get<LabInfo>(url).pipe(
            map((res) => {
                return {
                    orgName: res.businessName1,
                    capNumber: res.capNumber,
                    lbn2: null,
                    address1: null,
                    address2: null,
                    address3: null,
                    address4: null,
                    city: null,
                    county: null,
                    state: null,
                    province: null,
                    postalCode: null,
                    country: null,
                };
                // return res;
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    getContextualHelp() {
        const api = AppConfig.settings.apiServer.details.claimCmeCeContextualHelp;

        const headers = { IgnoreAuthorization: 'true' };

        return this.http.get(api, { headers, responseType: 'text' }).pipe(
            map((res) => {
                return res;
            }),
            catchError((err) => {
                console.error(err);

                return throwError(err);
            })
        );
    }

    getLabAffiliations$(): Observable<LabAffiliation[]> {
        const url = AppConfig.settings.apiServer.details.affiliation;

        return this.http.get<LabAffiliation[]>(url).pipe(
            map((res) => {
                return res;
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    assignKitToActivity$(organization: string, kitNumber: string): Observable<ActivityValidation> {
        const url =
            AppConfig.settings.apiServer.details.assignKitToActivity +
            `/organization/${organization}/kitNumber/${kitNumber}`;

        // return of('-102');
        // const url = 'http://localhost:3002/200-request';
        // const url = 'http://localhost:3002/400-request';
        // const url = 'http://localhost:3002/500-request';

        return this.http.post<ActivityValidation>(url, {}).pipe(
            map((res) => {
                return res;
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    getActivityRedirectUrl$(activityCode: string): Observable<string> {
        const url = AppConfig.settings.apiServer.details.activityRedirect.replace('{activityCode}', activityCode);

        return this.http.post(url, {}, { responseType: 'text' }).pipe(
            map((res: string) => {
                console.log('REDIRECT URL:', res);
                return res;
            }),
            catchError((err) => {
                console.error(err);
                return throwError(err);
            })
        );
    }

    constructor(private http: HttpClient) {}
}
